import { useEffect, useState } from 'react';
import Url from 'url-parse';

import type { IJourneyDefinition } from '../sdk/idscan-jcs';

import usePattern from './usePattern';

const useJourneyDefinitionId = (token: string, idscanServerUrl: string, fallback: () => void) => {
  const { pattern, patternWithCountry, defaultPattern } = usePattern();
  const [journeyDefinitionId, setJourneyDefinitionId] = useState<string>();
  const { href } = new Url(idscanServerUrl)
    .set('query', '')
    .set('pathname', '/IDScanEnterpriseSvc/JourneyDefinition/GetAll');

  useEffect(() => {
    token &&
      idscanServerUrl &&
      fetch(href, { headers: { authorization: token } })
        .then((res) => res.json())
        .then(
          (data: IJourneyDefinition[]) => {
            if (data.length) {
              const result = data.reduce((acc, journey) => {
                acc[journey.Name] = journey.JourneyDefinitionId;
                return acc;
              }, {} as Record<IJourneyDefinition['Name'], IJourneyDefinition['JourneyDefinitionId']>);
              setJourneyDefinitionId(
                result[patternWithCountry] ?? result[pattern] ?? result[defaultPattern]
              );
            } else {
              fallback();
            }
          },
          () => {
            fallback();
          }
        );
  }, [defaultPattern, idscanServerUrl, fallback, patternWithCountry, pattern, token, href]);

  return journeyDefinitionId;
};

export default useJourneyDefinitionId;
